import React from "react";

import "./Stepper.css";

const Step = ({ config: { percent, imgPath } }) => (
  <>
    <div style={{ display: "inline-block" }}>
      <div style={{ margin: -1 }}>
        {percent === 100 ? (
          <img src={imgPath} alt="" className="completed-step" />
        ) : (
          <img src={imgPath} alt="" />
        )}
      </div>
    </div>
  </>
);

export default Step;
